var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var MediaServiceController = {
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/mediaservice/{jobId?}" and http method "POST" to call the back-end.
    
        * @param {string} jobId
        * @returns {LinkDto}
    ******************************************************************************************************/
    MediaServiceWebHook: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/mediaservice/{jobId?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/mediaservice" and http method "OPTIONS" to call the back-end.
    
        * @returns {void}
    ******************************************************************************************************/
    MediaServiceWebHookOptions: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/mediaservice", __assign({}, data)),
            method: "OPTIONS",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=MediaServiceController.js.map